export enum TransactionStatusEnum {
  PROCESSANDO = 'Processando',
  COMPLETO = 'Completo',
  CANCELADO = 'Cancelado',
  COMPLETADO = 'Completado',
  COMPLETE = 'Complete',
}

export const TransactionStatusColors: Record<string, string> = {
  // Direct string mappings for API values
  Processando: 'purple',
  Completo: 'green-500',
  Cancelado: 'red',
  Completado: 'green-500',
  Complete: 'green-500',
};
